module.exports = __webpack_public_path__ + "media/images/top/feature_t-fe2c67db333ab6cbbfad1c6999603b03.gif";